import { render, staticRenderFns } from "./RequestedDocumentsTypesOfRequestedDocuments.vue?vue&type=template&id=3b6b52aa&"
import script from "./RequestedDocumentsTypesOfRequestedDocuments.vue?vue&type=script&lang=js&"
export * from "./RequestedDocumentsTypesOfRequestedDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports